import './index.scss';
import {withRouter} from 'react-router';

const bookconfig = {
    'hand': {
        title: '//s.qunarzz.com/vacation_tuan/2022/dalian/island.png',
        con: '//s.qunarzz.com/vacation_tuan/2022/dalian/book.png'
    },
    'camp': {
        title: '//s.qunarzz.com/vacation_tuan/2022/dalian/camptitle.png',
        con: '//s.qunarzz.com/vacation_tuan/2022/dalian/canpbook.png'
    }
};

class HandBook extends React.Component {
    render() {
        const {type} = this.props;
        const {title, con} = bookconfig[type];
        return (
            <div className="module m-hand-book">
                <img className="img-bg" src={title} />
                <img className="img-bg" data-sk-eid="detail" onClick={() => {
                    this.props.history.push(`/book/${type}`);
                }} src={con} />
            </div>
        );
    }
}

export default withRouter(HandBook);